import { useEffect, useCallback } from 'react'
import useOnWindowResize from './useOnWindowResize'

const useOnMediaQuery = (query, onMatch) => {
  const onChange = useCallback(() => {
    const { matches } = window.matchMedia(query)
    onMatch(matches)
  }, [query, onMatch])

  useEffect(() => { onChange() }, [])
  useOnWindowResize(onChange, 500)
}

export default useOnMediaQuery
